"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricContext = void 0;
;
;
;
;
;
;
;
var MetricContext;
(function (MetricContext) {
    MetricContext["OwnVolume"] = "own_volume";
    MetricContext["Shared"] = "shared";
    MetricContext["SharedPublic"] = "shared_public";
})(MetricContext || (exports.MetricContext = MetricContext = {}));
;
//# sourceMappingURL=telemetry.js.map